import React from 'react'
import { CMSContentItemProps } from '../CMSContentItem'
import { Link } from 'gatsby';
import { BsPersonFill } from "react-icons/bs";
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import { JsonLd } from 'gatsby-plugin-next-seo';
import { ContentType, ModelType } from '../../../types';
import { GATSBY_SITE_URL } from '../../pages/Page';
import { BlogPageData } from '../../pages/Blog';
import { DateTime } from 'luxon';
import { getBlogPageData } from './uitls';

type Props = {
    model: Partial<ModelType>;
    content: Partial<ContentType>[]
}

export default function BlogJsonLd({ model, content }: Props) {

    const modelDescription = model?.description || '';

    const origin = GATSBY_SITE_URL || window.location.origin;

    return (
        <JsonLd
            json={{
                "@context": "https://schema.org",
                "@type": "CollectionPage",
                "name": "Sailing Course Online Blog",
                "description": `${modelDescription}`,
                "url": `${origin}/blog`,
                "hasPart": content.map((item) => {
                    const contentData = getBlogPageData(item as BlogPageData);
                    const dateTime = DateTime.fromISO(contentData.date || '');
                    return {
                        "@type": "BlogPosting",
                        "headline": contentData.seoTitle || contentData.title,
                        "description": contentData.summary,
                        "author": contentData.author,
                        "datePublished": dateTime.toFormat("yyyy-MM-dd'T'hh:mm:ss"),
                        "dateModified": dateTime.toFormat("yyyy-MM-dd'T'hh:mm:ss"),
                    }
                })
            }}
        />
    )
}
